import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthorizerResponseDto } from '../../../model/authorizer-response-dto';
import { TenantResponseDto, TenantsService } from '../../../services/tenants.service';
import { AuthService } from '../../services/auth.service';

interface NavItem {
  label: string;
  link?: string;
  children?: NavItem[];
  permission?: () => boolean; // Function to check if user has access
}

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './nav-bar.html',
  styleUrls: ['./nav-bar.css'],
})
export class NavBarComponent implements OnInit {
  appName = 'Authorization System';
  currentUser: AuthorizerResponseDto | null = null;
  selectedTenant: TenantResponseDto | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private tenantsService: TenantsService
  ) {}

  ngOnInit(): void {
    this.authService.currentAuthorizer$.subscribe((authorizer) => {
      this.currentUser = authorizer;
    });

    this.selectedTenant = this.tenantsService.getSelectedTenant();
  }

  navLinks: NavItem[] = [
    {
      label: 'Authorizations',
      link: '/authorization',
      permission: () => true, // All authenticated users can view
    },
    {
      label: 'Authorizers',
      link: '/authorization/authorizers',
      permission: () => this.isAdminOrUser(), // Only admins (Company type)
    },
    {
      label: 'Authorizes',
      link: '/authorization/authorizes',
      permission: () => this.isAdminOrUser(), // Only admins (Company type)
    },
  ];

  userMenu = [
    { label: 'Profile', badge: '', link: '/authorization/profile' },
    { label: 'Change Company', badge: '', link: '/tenant-selector' },
    { label: 'Logout', badge: '', danger: true, action: () => this.logout() },
  ];

  isAdminOrUser(): boolean {
    return this.authService.isAdminOrUser();
  }

  logout(): void {
    this.authService.logout();
  }

  getLogoSrc(logoBase64: string | null): string {
    if (logoBase64) {
      if (logoBase64.startsWith('data:')) {
        return logoBase64;
      }

      return `data:image/png;base64,${logoBase64}`;
    }
    return '';
  }

  getUserInitials(): string {
    if (!this.currentUser?.name) return '?';
    const names = this.currentUser.name.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  }

  isChildActive(item: NavItem): boolean {
    if (!item.children) return false;
    return item.children.some((child) =>
      this.router.isActive(child.link || '', {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })
    );
  }
}
